import _ from 'underscore';
import moment from 'moment';
import 'moment-timezone';
import Papa from 'papaparse';

angular.module('am4').controller('equipmentWorkoutsCtrl', function($scope, $stateParams, $q, $translate, machineService, errorService, UserService, formatDistanceService, formatStrengthService, downloadService, $filter) {
    var that = this,
        workoutsPageSize = 50,
        workoutsCurrentPage = 1,
        facilityTz,
        unitPref;
    that.pageLength = 4;
    this.workouts = [];
    this.infiniteScrollDisabled = true;
    this.infiniteScrollDistance = 1;

    this.infiniteScrollFooter = require('../../views/equipment/historyFooter.html');

    function localizeWorkouts(workouts) {
        _.each(workouts, function(workout) {
            formatDistanceService.formatDistanceTotal(workout, unitPref, $scope.machineCtrl.detailData.modality, false);
            formatStrengthService.formatStrengthTotal(workout, unitPref, $scope.machineCtrl.detailData.modality, false);
            var started = moment(workout.started_at);
            workout.date = started.tz(facilityTz).format('l');
            workout.time = started.tz(facilityTz).format('LTS z (UTCZ)');
        });

        return workouts;
    }

    function sortWorkoutsDesc(workouts) {
        workouts.sort(function(a, b) {
            return moment(b.started_at).diff(moment(a.started_at));
        });
        return workouts;
    }

    this.download = function() {
        machineService.getMachineWorkouts($stateParams.id)
        .then(function(workouts) {
            var ret = {
                    data: []
                },
                workout,
                distanceStat,
                distanceField,
                machineIsStrength = $scope.machineCtrl.detailData.modality === 'strength',
                machineIsMassageChair = ['Massage Chair', 'massage_chair'].includes($scope.machineCtrl.detailData.modality);

            sortWorkoutsDesc(workouts);

            ret.data = workouts.map(wkt => {
                workout = wkt;
                formatDistanceService.formatDistanceTotal(workout, unitPref, $scope.machineCtrl.detailData.modality, true);
                formatStrengthService.formatStrengthTotal(workout, unitPref, $scope.machineCtrl.detailData.modality, true);

                if (machineIsStrength) {
                    distanceStat = workout.totalWeightForHistoryTab == null
                        ? ''
                        : workout.totalWeightForHistoryTab.toLocaleString({
                            maximumFractionDigits: 2
                        });
                } else if (machineIsMassageChair) {
                    distanceStat = $filter('massageProgram')(workout.massage_program);
                } else {
                    distanceStat = workout.totalDistance.toLocaleString({
                        maximumFractionDigits: 2
                    });
                }

                return [
                    moment(workout.started_at).tz(facilityTz).format(),
                    moment(workout.ended_at).tz(facilityTz).format(),
                    machineIsStrength ? workout.reps : workout.workout_time_formatted,
                    distanceStat,
                    workout.console_serial_number,
                    workout.facility_id
                ];
            });

            if (machineIsMassageChair) {
                distanceField = 'PROGRAM';
            } else if (machineIsStrength) {
                distanceField = 'WEIGHT';
            } else {
                distanceField = (workouts[0] && workouts[0].distanceUnit) || 'DISTANCE';
            }

            ret.fields = [
                $translate.instant('START'),
                $translate.instant('END'),
                machineIsStrength ? $translate.instant('CYCLES') : $translate.instant('DURATION'),
                $translate.instant(distanceField),
                $translate.instant('CONSOLE_SERIAL_NUMBER'),
                $translate.instant('FACILITY')
            ];

            downloadService('history-' + $stateParams.id + '.csv', Papa.unparse(ret));
        })
        .catch(function(e) {
            errorService.addError('MACHINE_HISTORY_ERROR', e);
        });
    };

    this.showMoreWorkouts = function() {
        this.infiniteScrollDisabled = true;
        machineService.getMachineWorkouts($stateParams.id, workoutsPageSize, workoutsPageSize * workoutsCurrentPage)
        .then(localizeWorkouts)
        .then(function(workouts) {
            // Only re-enable if there are more workouts
            if (workouts.length === workoutsPageSize) {
                that.infiniteScrollDisabled = false;
                workoutsCurrentPage++;
            }

            // Assignment instead of concat because we don't want to change the
            // underlying reference.  j should always be >= 50
            var i,
                j = that.workouts.length;

            for (i = 0; i < workouts.length; j++ && i++) {
                that.workouts[j] = workouts[i];
            }

            sortWorkoutsDesc(that.workouts);
        })
        .catch(function(e) {
            errorService.addError('MACHINE_HISTORY_ERROR', e);
        });
    };

    // Set initial workouts state
    $q.all([
        $scope.machineCtrl.workoutsPromise,
        $scope.machineCtrl.facility,
        UserService.user
    ])
    .then(function(res) {
        var fac = res[1],
            user = res[2];

        facilityTz = fac.time_zone;
        unitPref = user.unit_preference;

        // We're referencing the machineCtrl workouts so they don't reload on tab change
        that.workouts = $scope.machineCtrl.workouts;
        localizeWorkouts(that.workouts);
        sortWorkoutsDesc(that.workouts);

        // Enable if there are potentially more workouts
        if (that.workouts.length === workoutsPageSize) {
            that.infiniteScrollDisabled = false;
        }
    })
    .finally(function() {
        // We're doing this here instead of machineCtrl because we want the
        // spinner to show up until everything is loaded
        $scope.machineCtrl.workoutsLoaded = true;
    });
});



// WEBPACK FOOTER //
// ./src/app/controllers/equipment/equipmentWorkoutsCtrl.js